// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type ToggleFavouriteMutationVariables = Exact<{
  gameId: string | number;
}>;


export type ToggleFavouriteMutation = { casinoToggleFavourite: { favouriteGameNode: { id: string, isFavourite: boolean | undefined } | undefined, errors: Array<{ code: number | undefined, message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const ToggleFavouriteMutationDocument = gql`
    mutation ToggleFavouriteMutation($gameId: ID!) {
  casinoToggleFavourite(input: { gameId: $gameId }) {
    favouriteGameNode {
      id
      isFavourite
    }
    errors {
      code
      message
      params {
        name
        value
      }
    }
  }
}
    `;